/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { FeedbackTypeStep } from './Steps/FeedbackTypeStep';
import { FeedbackContentStep } from './Steps/FeedbackContentStep';
import { FeedbackSucessStep } from './Steps/FeedbackSucessStep';

// armazenar todos os tipos de button e conteúdo para facilitar se houver manutenção.
export const feedbackTypes = {
  BUG: {
    title: 'Problema',
    image: {
      source: '/images/bug.svg',
      alt: 'Reportar um problema',
    },
  },
  IDEA: {
    title: 'Ideia',
    image: {
      source: '/images/idea.svg',
      alt: 'Sugerir uma ideia',
    },
  },
  OTHER: {
    title: 'Outro',
    image: {
      source: '/images/thought.svg',
      alt: 'Informar sobre outro assunto',
    },
  },
};

// Seleciona somente as chaves dos elementos do feedbackTypes.
export function WidgetForm() {
  const [feedbackType, setFeedbackType] = useState(null);
  // saber se o feedback foi enviado ou não encontrado
  const [feedbackSent, setFeedbackSent] = useState(false);
  function handleRestartFeedback() {
    setFeedbackSent(false);
    setFeedbackType(null);
  }

  return (
    <div className="bg-primary-500 p-4 relative rounded-2xl mb-4 flex flex-col items-center shadow-lg w-[calc(100vw-2rem)] md:w-auto z-50">
      {
        feedbackSent ? (
          <FeedbackSucessStep onFeedbackRestartRequested={handleRestartFeedback} />
        ) : (
          <>
            {
              !feedbackType ? (
                <FeedbackTypeStep onFeedbackTypeChanged={setFeedbackType} />
              ) : (
                <FeedbackContentStep
                  feedbackType={feedbackType}
                  onFeedbackRestartRequested={handleRestartFeedback}
                  onFeedbackSent={() => setFeedbackSent(true)}
                />
              )
            }
          </>
        )
      }
    </div>
  );
}
